import { CLUSTER_PINS_GRIDS } from '../clusterPinsGrids';
import { TClusterPin } from './types';

// Слот сетки раскрытого кластера для конкретного пина.
// Сетка выбирается по видимому количеству пинов min(pinsCount, maxPinsPerCluster):
// на мобвебе ромашка усечена; слот за лимитом устройства не рисуется (null).
// Единая точка, откуда координата (getClusterPinCoordinates), z-index (getBalloonZIndex)
// и anchor (BalloonManager) берут параметры ОДНОГО и того же слота — без рассинхрона.
export function getGridPin(pinsCount = 1, pinIndex = 0, maxPinsPerCluster: number): TClusterPin | null {
  if (pinIndex >= maxPinsPerCluster) {
    return null;
  }

  const grid = CLUSTER_PINS_GRIDS[Math.min(pinsCount, maxPinsPerCluster)];

  return grid?.[pinIndex] ?? null;
}
